import { httpServiceClient, queryClient } from '@/infra/http'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  UserContentDetailsQuery,
  UserContentDetailsResponse
} from './user-content-details-service-types'
import { formatUserContentDetails } from './user-content-details-service-utils'

const getUserContentUrl = () => makeApiUrl('/v2/user/content/product')

export const userContentDetailsService = {
  async fetchQueryUserContentDetails(id: number, toEnrollment?: boolean) {
    const response = await queryClient.fetchQuery({
      queryKey: ['user-content-details', id, toEnrollment],
      queryFn: () => userContentDetailsService.fetchUserContentDetails(id, { toEnrollment }),
      staleTime: 1000
    })

    return response
  },

  async fetchUserContentDetails(id: number, query: UserContentDetailsQuery = {}) {
    const pathUrl = `${getUserContentUrl()}/${id}`

    const response = await httpServiceClient<UserContentDetailsResponse>({
      method: 'get',
      url: pathUrl,
      params: {
        toEnrollment: query.toEnrollment
      },
      paramsNamingStrategy: NamingStrategy.snakeCase
    })

    return formatUserContentDetails(response.body.data as UserContentDetailsResponse)
  }
}
